import { CarrierProductionFileId } from '../reporting/carrier-production-raw-carrier-file.model';

export enum ProcessCarrierProductionRawFilePayloadKeys {
  year = 'year',
  reportDate = 'reportDate',
  carrierFileId = 'carrierFileId',
  uploadActionId = 'uploadActionId',
}

export interface ProcessCarrierProductionRawFilePayload {
  [ProcessCarrierProductionRawFilePayloadKeys.year]: string;
  [ProcessCarrierProductionRawFilePayloadKeys.reportDate]: string;
  [ProcessCarrierProductionRawFilePayloadKeys.carrierFileId]: CarrierProductionFileId;
  [ProcessCarrierProductionRawFilePayloadKeys.uploadActionId]: string;
}
